import {
    ConditionType,
    ConditionType_Excludes,
    ConditionType_Includes,
} from "../../model2/conditions/condition-types"
import Filter from "../../manager/filters/manager/filter"
import Project from "../../model2/project/project"

export const FieldConditionsDropdown_NotSetOption = {
    value: null,
    label: 'Not set'
}

export const FieldConditionsDropdown_NotAssignedOption = {
    value: null,
    label: 'Not assigned'
}

export const FIELD_CONDITIONS_DROPDOWN     = [
    ConditionType_Includes,
    ConditionType_Excludes,
]

// const debugDropdown = 'FieldDropdown_filterFunc'
const debugDropdown = false

export function FieldDropdown_filterFunc(filter: Filter, model:any): boolean {

    debugDropdown && console.log(debugDropdown, 'process', filter, model)

    if (!filter.type || !filter.value || _.isEmpty(filter.value)) return true

    let fieldValue: any = _.get(model, filter.field?.fieldId!, FieldConditionsDropdown_NotSetOption.value)

    const filterValue = filter.value || []

    let res = false
    switch (filter.type) {
        case ConditionType.INCLUDES:
            res = filterValue.includes(fieldValue)
            break

        case ConditionType.EXCLUDES:
            res = !filterValue.includes(fieldValue)
            break
    }

    debugDropdown && console.log(debugDropdown, 'process res', res, filter.type, filterValue, fieldValue)

    return res
}

export function FieldMultiselect_filterFunc(filter: Filter, model:any): boolean {

    if (!filter.type || !filter.value || _.isEmpty(filter.value)) return true;  // Esli net condition type propuskaem filter

    let fieldValue: any = _.get(model, filter.field?.fieldId!, FieldConditionsDropdown_NotSetOption.value)

    const filterValue = filter.value || []

    switch (filter.type) {
        case ConditionType.INCLUDES:
            return _.intersection(filterValue,fieldValue).length > 0 ||                             // check values
                (!fieldValue && filterValue.includes(FieldConditionsDropdown_NotSetOption.value))   // check for 'Not set'
        case ConditionType.EXCLUDES:
            return !(_.intersection(filterValue,fieldValue).length > 0) &&                          // check values
                !(!fieldValue && filterValue.includes(FieldConditionsDropdown_NotSetOption.value))  // check for 'Not set'
        default:
            return false
    }

}

export function FieldRating_filterFunc(filter: Filter, model:any): boolean {

    if (!filter.type) return true;  // Esli net condition type propuskaem filter

    let fieldValue: number | null = _.get(model, filter.field?.fieldId!, null)

    const filterValue = filter.value || []

    // In filters NotSet = null. In options NotSet = 0. Menyat srazu vezde ne mojem naverno?!
    if (fieldValue === null) {
        fieldValue = 0
    }

    switch (filter.type) {
        case ConditionType.INCLUDES:
            return filterValue.includes(fieldValue)
        case ConditionType.EXCLUDES:
            return !filterValue.includes(fieldValue)
        default:
            return false
    }

}

// const debugProjectUsers = 'FieldProjectUsers_filterFunc'
const debugProjectUsers = false

export function FieldProjectUsers_filterFunc(filter: Filter, model:any): boolean {

    if (!filter.type || !filter.value || _.isEmpty(filter.value)) return true

    let fieldValue: any = _.get(model, filter.field?.fieldId!, FieldConditionsDropdown_NotSetOption.value)
    if (fieldValue) {
        fieldValue = _.map(fieldValue, (user: any) => {
            return user.id
        })
    } else {
        fieldValue = (model as Project).allUsers
    }

    const filterValue = filter.value || []

    debugProjectUsers && console.log(debugProjectUsers, 'process', filter.field?.fieldId, filterValue, fieldValue, model)

    switch (filter.type) {
        case ConditionType.INCLUDES:
        case ConditionType.ARRAY_INTERSECTION:
            return _.intersection(filterValue,fieldValue).length > 0 ||                             // check values
                (!fieldValue && filterValue.includes(FieldConditionsDropdown_NotSetOption.value))   // check for 'Not set'
        case ConditionType.EXCLUDES:
        case ConditionType.ARRAY_NON_INTERSECTION:
            return !(_.intersection(filterValue,fieldValue).length > 0) &&                          // check values
                !(!fieldValue && filterValue.includes(FieldConditionsDropdown_NotSetOption.value))  // check for 'Not set'
        default:
            return false
    }

}

export function FieldProjectStatus_filterFunc(filter: Filter, model:any): boolean {

    debugDropdown && console.log(debugDropdown, 'process', filter, model)

    if (!filter.type || !filter.value || _.isEmpty(filter.value)) return true

    let fieldValue: any = _.get(model, filter.field?.fieldId!, null)
    if (!fieldValue) {
        fieldValue = (model as Project).systemStatus
    }

    const filterValue = filter.value || []

    debugDropdown && console.log(debugDropdown, 'process values', fieldValue, filterValue)

    switch (filter.type) {
        case ConditionType.INCLUDES:
            return filterValue.includes(fieldValue)
        case ConditionType.EXCLUDES:
            return !filterValue.includes(fieldValue)
        default:
            return false
    }

}

/** --- Filter Options Filler --- **/
export function FieldDropdown_filterValuesFiller(filter: Filter, model:any) {
    const value = _.get(model, filter.field!.fieldId, null)
    return value ? [value] : []
}

export function FieldMultiselect_filterValuesFiller(filter: Filter, model:any) {
    const values = _.get(model, filter.field!.fieldId, null)
    return values || []
}

export function FieldProjectUsers_filterValuesFiller(filter: Filter, model:any) {
    const values = _.get(model, filter.field!.fieldId, null)

    if (values) {
        return _.map(values, (user: any)=>{
            return user.id
        })
    } else {
        return (model as Project).allUsers
    }
}

export function FieldProjectStatus_filterValuesFiller(filter: Filter, model:any) {
    const value = _.get(model, filter.field!.fieldId, null)

    if (value) {
        return [value]
    } else {
        return [(model as Project).systemStatus]
    }
}